import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UI_PIPES } from '@maximizer/core/shared/ui/pipes';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_DIALOG } from '@progress/kendo-angular-dialog';
import { KENDO_CHECKBOX } from '@progress/kendo-angular-inputs';
import { KENDO_LABEL } from '@progress/kendo-angular-label';
import { AiHubStore } from '../ai-hub.store';
import { PreferenceCardComponent } from './preference-card/preference-card.component';

let nextConsentId = 0;

@Component({
  selector: 'ai-hub-preferences-tab',
  templateUrl: './preferences-tab.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [KENDO_BUTTON, KENDO_CHECKBOX, KENDO_DIALOG, KENDO_LABEL, PreferenceCardComponent, TranslatePipe, UI_PIPES],
})
export class PreferencesTabComponent {
  readonly store = inject(AiHubStore);
  readonly consentPanelShown = input(false);
  readonly consentId = `exchange-consent-${nextConsentId++}`;

  onConsentChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const ticked = input.checked;
    input.checked = this.store.consentGiven();
    if (ticked) this.store.giveConsent();
    else this.store.requestWithdrawConsent();
  }
}
